// src/modules/myvault/hooks/useMyVaultAgentVisibility.ts
//
// Hook to control visibility of the MyVault Agent chat widget.
// The agent should be visible everywhere in MyVault EXCEPT when running a Canvas App.

import { useLocation } from "react-router-dom";

/**
 * Hook to determine if the MyVault Agent chat widget should be visible.
 *
 * Returns false when:
 * - User is viewing a canvas app in runtime mode (canvases/:id without /edit)
 *
 * Returns true for:
 * - Schema browser/builder
 * - View browser/builder
 * - Canvas browser
 * - Canvas builder (edit mode)
 */
export const useMyVaultAgentVisibility = (): boolean => {
  const location = useLocation();
  const path = location.pathname;

  // Check if we're on a canvas runtime page (viewing, not editing)
  // Pattern: /workspace/:workspaceId/myvault/canvases/:canvasId
  // But NOT: /workspace/:workspaceId/myvault/canvases/:canvasId/edit
  // And NOT: /workspace/:workspaceId/myvault/canvases/create

  // Match pattern: /myvault/canvases/{id} where id is not "create" and path doesn't end with /edit
  const canvasRuntimePattern = /\/myvault\/canvases\/([^/]+)$/;
  const match = path.match(canvasRuntimePattern);

  if (match) {
    const canvasIdOrAction = match[1];
    // If it's "create" or the path ends with this match and it's just a canvas ID (not create)
    // then it's runtime mode - hide the agent
    if (canvasIdOrAction !== "create") {
      return false;
    }
  }

  // For all other MyVault routes, show the agent
  return true;
};

export default useMyVaultAgentVisibility;
